var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-table',{attrs:{"url":"/api/v1/priceLevel","filter":[
    {
      name: 'sort',
      mode: 'DESC',
      attribute: 'at_amount'
    }
  ],"attributes":[
    {
      attribute: 'at_amount',
      name: 'Ab Einheiten'
    },
    {
      attribute: 'bonus',
      name: 'Bonus'
    },
    {
      attribute: 'update_page_url',
      name: 'Bearbeiten',
      type: 'ActionCell',
      label: 'Bearbeiten',
      sortable: false
    },
    {
      attribute: 'update_url',
      name: 'Löschen',
      type: 'DeleteCell',
      label: 'Löschen',
      sortable: false
    }
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }